// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2gB_I","filesListContainer":"PosDisputesFiles_filesListContainer__9M9AX","filesButton":"PosDisputesFiles_filesButton__1xjPl"};